export interface FieldMapping {
  id?: number;
  source_field_key: string;
  target_field: string;
}

export interface ProjectStageConfig {
  id: number;
  location_id: string;
  company_id: number | null;
  company_name: string | null;
  pipeline_id: string;
  pipeline_name: string;
  trigger_stage_id: string;
  trigger_stage_name: string;
  project_status_id: number;
  project_status_name: string;
  is_active: boolean;
  sync_contact_notes: boolean;
  field_mappings: FieldMapping[];
  created_at: string;
  updated_at: string;
}

export interface CompanyOption {
  id: number;
  name: string;
}

export interface ProjectStatus {
  id: number;
  name: string;
}

export interface PipelineStage {
  id: string;
  name: string;
  sort_order?: number;
}

export interface Pipeline {
  id: string;
  name: string;
  stages: PipelineStage[];
}

export interface CustomField {
  id: string;
  name: string;
  field_key: string;
  object_type: string;
}

export interface SourceField {
  key: string;
  label: string;
  group: string;
}

export interface JobConfigProps {
  locationId: string;
  ssoToken: string;
}

export const TARGET_FIELD_GROUPS = [
  {
    label: 'Project',
    fields: [
      { value: 'project.alias', label: 'Project Alias' },
      { value: 'project.notes', label: 'Project Notes' },
    ],
  },
  {
    label: 'Address',
    fields: [
      { value: 'address.street', label: 'Street' },
      { value: 'address.city', label: 'City' },
      { value: 'address.state', label: 'State' },
      { value: 'address.zip', label: 'ZIP Code' },
      { value: 'address.country', label: 'Country' },
    ],
  },
  {
    label: 'Property',
    fields: [
      { value: 'property.name', label: 'Property Name' },
      { value: 'property.year_built', label: 'Year Built' },
      { value: 'property.loss_date', label: 'Loss Date' },
      { value: 'property.loss_class', label: 'Loss Class' },
      { value: 'property.is_residential', label: 'Is Residential' },
      { value: 'property.is_commercial', label: 'Is Commercial' },
      { value: 'property.referred_by_name', label: 'Referred By' },
      { value: 'property.arrived_on_site', label: 'Arrived On Site' },
    ],
  },
  {
    label: 'Claim',
    fields: [
      { value: 'claim.policy_holder', label: 'Policy Holder' },
      { value: 'claim.policy_holder_email', label: 'Policy Holder Email' },
      { value: 'claim.policy_holder_phone', label: 'Policy Holder Phone' },
      { value: 'claim.representative', label: 'Representative' },
      { value: 'claim.ownership_status', label: 'Ownership Status' },
      { value: 'claim.provider', label: 'Insurance Provider' },
      { value: 'claim.insurance_deductible', label: 'Insurance Deductible' },
      { value: 'claim.policy_number', label: 'Policy Number' },
      { value: 'claim.claim_number', label: 'Claim Number' },
      { value: 'claim.adjuster', label: 'Adjuster' },
      { value: 'claim.adjuster_email', label: 'Adjuster Email' },
      { value: 'claim.adjuster_phone', label: 'Adjuster Phone' },
    ],
  },
];
